import { saveAs } from 'file-saver';
import printJS from 'print-js';

export const downloadFile = (url: string, fileName = 'hos_export.pdf'): void => {
  saveAs(url, fileName);
};

export const printFile = (url: string): void => {
  printJS({
    printable: url,
    type: 'pdf',
    showModal: false,
  });
};
